import {
  fixFeatureButton,
  customizeSearch,
  createCustomToggle,
  updateContentMargin,
} from '../js/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  customizeSearch();
  createCustomToggle();
  updateContentMargin();
  modifySignup();
});
// ***************************************************************************************************************************************************
// Function to customize the signup widget on the homepage

function modifySignup() {
  const signupWidget = $('.homepage .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h2>Join the Fun</h2>
        <p>Get the latest updates from Fort Bend County Fair & Rodeo</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Enter Email...')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('Subscribe');
  });
}
